
export const toRadians = (angle) => {
  return angle * (Math.PI / 180);
}
